import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconChevronBottomOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 22.98c-.26 0-.52-.1-.7-.3L3.32 10.7a.967.967 0 0 1 0-1.4c.4-.38 1.02-.4 1.4 0l11.26 11.26L27.26 9.3a.99.99 0 0 1 1.42 0c.4.4.4 1.02 0 1.42L16.7 22.7c-.2.2-.46.3-.7.3z" /></svg>;
export default SvgIconChevronBottomOutlined;